module.exports = __webpack_public_path__ + "static/media/Avatar5.db54c5cd.svg";